import React from "react";

function InfoIcon() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={682.667}
    height={682.667}
    viewBox="0 0 512 512"
  >
    <path d="M290.5 1.6c-13.8 2.9-27.4 11.4-36.3 22.7-9.2 11.6-12.5 21.1-12.6 35.7 0 19.7 9.8 37 27.5 48.6 18.8 12.3 45.8 13.8 66.4 3.8 13-6.4 25.7-20.6 30.4-33.9 4.8-13.4 3.7-30.2-2.6-43.5-4.9-10.3-16.6-22-27.8-27.7-13.4-6.9-29.5-8.9-45-5.7zM232.5 174.1c-16.1 1.7-36.7 7.7-68.6 19.8l-13.7 5.3-3.5 14.1c-2 7.8-3.4 14.3-3.2 14.5.2.2 5.3-1.3 11.4-3.2 14.7-4.8 27.2-6.3 38.4-4.9 19.4 2.6 25.7 10.6 25.7 32.6 0 15.4-4.1 33-23.5 101.2-15.7 55.1-19.5 74.8-18.2 94.8 2 31.6 22.7 53.9 57.2 61.3 16.7 3.6 43.3 2.7 61.2-2 8.3-2.2 48.8-16.9 56.2-20.5 3.4-1.6 3.5-1.9 6.8-15.5 1.8-7.6 3.2-14 3-14.2-.1-.2-3.3.8-7 2.1-12.4 4.6-26 6.8-37.7 6.2-16.9-.9-24.8-4.8-29.4-14.7-1.8-3.9-2.1-6.3-2-18 .1-14.6 2.6-29.9 8.4-50.2 27.9-98.2 29.3-103.9 31-119.3 4-35.5-.1-51.8-16.9-68.5-9.8-9.8-18.5-14.7-31.6-18-14.7-3.7-27.8-4.6-44-2.9z" />
  </svg>
  );
}

export default InfoIcon;